module.exports = __webpack_public_path__ + "img/DVR8.b9e7932a.png";